/**
 * @generated SignedSource<<36a6e8968193f7454219eae8f2228cbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountProfilePageQuery$variables = {};
export type AccountProfilePageQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"UserProfile_user">;
  } | null;
};
export type AccountProfilePageQuery = {
  response: AccountProfilePageQuery$data;
  variables: AccountProfilePageQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountProfilePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserProfile_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountProfilePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemsPerPage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "027b96fd287c142e16f55ec7dc2674ef",
    "id": null,
    "metadata": {},
    "name": "AccountProfilePageQuery",
    "operationKind": "query",
    "text": "query AccountProfilePageQuery {\n  viewer {\n    ...UserProfile_user\n    id\n  }\n}\n\nfragment UserProfile_user on User {\n  id\n  name\n  email\n  itemsPerPage\n}\n"
  }
};

(node as any).hash = "6ebdee0f805c823f5318ee85d88f4155";

export default node;
